import { formatTime } from '../helpers';

/**
 * Body for POST /schedules/ and PATCH /schedules/{id}.
 * @typedef {Object} SchedulePayload
 * @property {string} deviceId  device MAC
 * @property {'ESS'|'TGS'|'TES'} deviceType
 * @property {string} startDate  UTC, `YYYY-MM-DDTHH:mm:ssZ`
 * @property {string} endDate  UTC, `YYYY-MM-DDTHH:mm:ssZ`
 * @property {number} threshold  °C
 */

/**
 * @param {Object} schedule
 * @param {string} schedule.deviceMac
 * @param {'ESS'|'TGS'|'TES'} schedule.deviceType
 * @param {{date: Date, time: {hour: string, minute: string, division: string}}} schedule.start
 * @param {{date: Date, time: {hour: string, minute: string, division: string}}} schedule.end
 * @param {number} schedule.temp  °C
 * @returns {SchedulePayload}
 */
export const schedulePayload = ({ deviceMac, deviceType, start, end, temp }) => ({
  deviceId: deviceMac,
  deviceType,
  startDate: formatTime({ ...start }),
  endDate: formatTime({ ...end }),
  threshold: temp,
});
